import { render, staticRenderFns } from "./RezzervationConnection.vue?vue&type=template&id=568ce7be&"
import script from "./RezzervationConnection.vue?vue&type=script&lang=js&"
export * from "./RezzervationConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports